  import { FormGroup } from '@angular/forms';
  export interface SearchModelV2 {
    label;
    dataType;
    form: FormGroup;
    options?;
  }
  export abstract class SearchModelV2Class implements SearchModelV2 {
    label;
    dataType;
    form: FormGroup;
    options;

    constructor(label, dataType, form, options?) {
      this.label = label;
      this.dataType = dataType;
      this.form = form;
      this.options = options;
    }
  }
